module.exports = __webpack_public_path__ + "static/bentonsans-extralight-webfont-118b46abc19f4fee397981778897c2ae.woff";